import { render } from "./EvvDetailsHomeHealth.vue?vue&type=template&id=673f6dac&scoped=true"
import script from "./EvvDetailsHomeHealth.ts?vue&type=script&lang=js&external"
export * from "./EvvDetailsHomeHealth.ts?vue&type=script&lang=js&external"

import "./EvvDetailsHomeHealth.vue?vue&type=style&index=0&id=673f6dac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673f6dac"]])

export default __exports__